module.exports = __webpack_public_path__ + "img/cart-orange.e706fa55.svg";